import { gql } from '@apollo/client'
import React from 'react'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import { auditClient } from '../../../utils/apollo/api'
import StatePresenter from '../../../packages/kiti/components/helpers/StatePresenter'
import LazyAction from '../../../packages/kiti/components/helpers/LazyAction'

const Context = React.createContext()
const { Provider } = Context
export const useAuditsState = () => React.useContext(Context) || {}
export const useAudits = () => useAuditsState()?.audits || []

const QUERY = gql`
  query Audits($page: Int, $search: String, $sort: AuditSort, $filter: AuditFilter) {
    audits(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      operation
      recordId
      before
      after
      insertedAt
      createdBy {
        id
        name
      }
    }
  }
`

const AuditLoader = ({ children, uncontrolledChildren, entity, id }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: 'INSERTED_AT', type: 'DESC' },
      filter: {
        recordId: id,
        entity
      }
    },
    client: auditClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default AuditLoader
